import { Modal, notification, Form, Button } from "antd";
import { authService } from "../../../services";
import MaterialLikePasswordInput from "../../../components/MaterialLikeInputPassword";
import { useState } from "react";

export default function ChangePasswordModal({ open, setOpen }) {

    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);

    const handleCancel = () => {
        form.resetFields();
        setOpen(false)
    };

    const onFinish = async (values) => {
        setLoading(true);
        const { success } = await authService.changedPassword(values);
        if (success) {
            notification.success({ message: "Password changed successfully" });
            handleCancel();
        }
        setLoading(false);
    };

    return (
        <Modal
            title={
                <div style={{ textAlign: "center", width: "100%" }}>
                    Change Password
                </div>
            }
            open={open}
            onCancel={handleCancel}
            footer={null}
            width={550}
            style={{ padding: "0px", top: 80 }}
        >
            <Form
                requiredMark={false}
                form={form}
                layout="vertical"
                name="change_password"
                onFinish={onFinish}
            >
                <Form.Item
                    name="old_password"
                    rules={[
                        { required: true, message: "Please enter your old password!" },
                    ]}
                >
                    <MaterialLikePasswordInput
                        label="Old Password"
                        required
                        value={form.getFieldValue("old_password")}
                        onChange={(e) => form.setFieldValue("old_password", e.target.value)} />
                </Form.Item>

                <Form.Item
                    name="password"
                    rules={[
                        { required: true, message: "Please enter your new password!" },
                        {
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();

                                const validations = {
                                    length: value.length >= 8,
                                    uppercase: /[A-Z]/.test(value),
                                    lowercase: /[a-z]/.test(value),
                                    number: /[0-9]/.test(value),
                                    special: /[!@#$%^&*]/.test(value),
                                };

                                const allValid = Object.values(validations).every(Boolean);
                                if (!allValid) {
                                    return Promise.reject(
                                        new Error(
                                            "Password must be at least 8 characters, include uppercase, lowercase, number, and special character."
                                        )
                                    );
                                }
                                return Promise.resolve();
                            },
                        },
                    ]}
                >
                    <MaterialLikePasswordInput
                        label="New Password"
                        type="password"
                        showValidation={true}
                        required
                        value={form.getFieldValue("password")}
                        onChange={(e) => form.setFieldValue("password", e.target.value)}
                    />
                </Form.Item>


                <Form.Item
                    name="password_confirmation"
                    rules={[
                        {
                            required: true,
                            message: "Please confirm your new password!",
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("password") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error("Passwords do not match!"));
                            },
                        }),
                    ]}
                >
                    <MaterialLikePasswordInput
                        label="Confirm Password"
                        type="password"
                        required
                        value={form.getFieldValue("password_confirmation")}
                        onChange={(e) => form.setFieldValue("password_confirmation", e.target.value)} />
                </Form.Item>
                <div className="flex justify-end gap-3">
                    <Button variant="outlined" color="primary" onClick={handleCancel} >
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" loading={loading} >
                        Update Password
                    </Button>
                </div>
            </Form>
        </Modal>
    )
}   